<template>
    <div>
        <v-card class="pb-1">
            <v-card-title>
                <span class="headline">Documentos / Información Movimientos de Aceite</span>
            </v-card-title>
            <v-progress-linear v-if="cargando" indeterminate color="blue darken-2"></v-progress-linear>
            <v-progress-linear v-if="error_load" indeterminate color="red darken-3"></v-progress-linear>
            <v-card-text class="pb-1">
                <v-row>
                    <v-col cols="2">
                        <v-select
                            :items="tipo_producciones"
                            v-model="tipo_produccion_id"
                            label="Tipo Producción"
                            item-text="tipo_produccion"
                            item-value="id"
                        ></v-select>
                    </v-col>
                    <v-col cols="2">
                        <v-select
                            :items="tipo_movimientos"
                            v-model="tipo_movimiento"
                            label="Ingreso o Salida"
                            item-text="texto"
                            item-value="valor"
                        ></v-select>
                    </v-col>
                    <v-col cols="2">
                        <v-select
                            :items="motivo_movimientos"
                            v-model="motivo_movimiento"
                            label="Motivo Movimiento"
                            item-text="texto"
                            item-value="valor"
                        ></v-select>
                    </v-col>
                    <v-col cols="2">
                        <v-text-field v-model="documento" label="Documento / Información"></v-text-field>
                    </v-col>
                    <v-col cols="2">
                        <v-select
                            :items="tipo_datos"
                            v-model="tipo_dato"
                            label="Tipo Dato"
                            item-text="texto"
                            item-value="valor"
                        ></v-select>
                    </v-col>
                    <v-col cols="1">
                        <v-select
                            :items="[{id: 0, text: 'No'}, {id: 1, text: 'Sí'}]"
                            v-model="activo" 
                            label="Activo"
                            item-text="text"
                            item-value="id"
                        ></v-select>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-col cols="6">
                    <alert></alert>
                </v-col>
                <v-col cols="2">
                    <v-btn color="green darken-1" dark @click="submit" :disabled="!validar"> Guardar </v-btn>
                </v-col>
                <v-col cols="2">
                    <v-btn color="indigo darken-1" dark @click="limpiar()">Limpiar</v-btn>
                </v-col>
            </v-card-actions>
        </v-card>

        <v-card>
            <template>
                <div>
                    <v-data-table
                        :headers="cabeceras"
                        :items="lista_datitos"
                        item-key="name"
                        class="elevation-1"
                        :search="search"
                        :custom-filter="filterOnlyCapsText"
                    >
                        <template v-slot:top>
                            <v-text-field
                                v-model="search"
                                label="Búsqueda"
                                class="mx-4"
                            ></v-text-field>
                        </template>

                        <template v-slot:item.activo="{ item }">
                            <td v-if="item.activo">
                                <v-icon color="green">done</v-icon>
                            </td>
                            <td v-else>
                                <v-icon color="red">clear</v-icon>
                            </td>
                        </template>
                        <template v-slot:item.options="{ item }">
                            <td>
                                <v-row v-if="item.tipo_dato == '5'" cols="10">
                                    <v-col cols="9">
                                        <v-combobox
                                            v-model="item.opciones"
                                            :items="item.opciones"
                                            item-text="opcion"
                                            item-value="id"
                                            label="Opciones"
                                            multiple
                                            chips
                                        ></v-combobox>
                                    </v-col>
                                    <v-col cols="3" class="d-flex align-center pl-1">
                                        <v-btn class="ma-2" color="indigo" dark icon @click="grabar_select(item)" title="Guardar opciones">
                                            <v-icon dark>save</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </td>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <div>
                                <v-btn color="red" title="Eliminar documento" dark small>
                                    <v-icon @click="eliminarMovDocumento(item)">delete</v-icon>
                                </v-btn>
                            </div>
                        </template>
                    </v-data-table>
                </div>
            </template>
        </v-card>
        <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
    </div>
</template>
<script>
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import Alert from '@/components/shared/Alert.vue';
import { mapState, mapMutations } from 'vuex';
import ConfirmDialogue from '@/components/ConfirmDialogue.vue'
export default {
    data:()=>({
        // Form
        tipo_producciones: [],
        tipo_produccion_id: '',
        tipo_movimientos: [],
        tipo_movimiento: '',
        motivo_movimientos: [],
        motivo_movimiento: '',
        documento: '',
        tipo_datos: [],
        tipo_dato: '',
        activo: 1,

        // Cargando
        cargando: false,
        error_load: false,
        
        // Table
        search: '',
        lista_datos: [],
        cabeceras: [
            { text: 'Producción', align: 'start', value: 'produccion', },
            { text: 'Movimiento', value: 'movimiento' },
            { text: 'Motivo Mov', value: 'motivo' },
            { text: 'Documento', value: 'documento' },
            { text: 'Tipo Dato', value: 'tipo' },
            { text: 'Activo', value: 'activo' },
            { text: 'Opciones', value: 'options' },
            { text: 'Acciones', value: 'actions' },
        ],
    }),
    mounted(){
        this.limpiar();
        this.cargarDatos();
        this.listarDatos();
    },
    methods:{
        async submit(){
            this.cargando = true;

            if (this.validar){
                console.log('enviando peticion');
                const url = `${this.base_url}mov_documentos`;
                const body = {
                    tipo_produccion_id: this.tipo_produccion_id,
                    tipo_movimiento: this.tipo_movimiento,
                    motivo_movimiento: this.motivo_movimiento,
                    documento: this.documento,
                    tipo_dato: this.tipo_dato,
                    activo: this.activo,
                }

                await this.axios.post(url, body, this.headers).then(res => {
                    if(res.data.message != "Error"){
                        this.documento = ''
                        this.listarDatos();
                    } else {
                        Event.$emit('mostrar_alert', {tipo: "success", mensaje: "Registro ya existe"});
                    }
                }).catch(error => {
                    console.log('error',error);
                    Event.$emit('mostrar_alert',{tipo: "error",mensaje: (error.message ? error.message : error)});
                });
            } else {
                console.log('nope');
                Event.$emit('mostrar_alert',{tipo: "success",mensaje: "No están todos los datos"})
            }
            this.cargando = false;
        },

        limpiar(){
            this.tipo_produccion_id = '';
            this.tipo_movimiento = '';
            this.motivo_movimiento = '';
            this.documento = '';
            this.tipo_dato = '';
            this.activo = 1;
        },

        async cargarDatos(){
            this.cargando = true;
            this.mostrarLoading({titulo:'Cargando Datos...',color:'green'})
            const url = `${this.base_url}mov_documento/cargar_datos`;
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('cargar_datos',response);
                this.tipo_producciones = response.data.producciones;
                this.tipo_movimientos = response.data.movimientos;
                this.motivo_movimientos = response.data.motivos;
                this.tipo_datos = response.data.tipos;
                this.error_load = false;
            }).catch((error)=>{
                console.log(error);
                this.error_load = true;
            });
            this.cargando = false;
            this.ocultarLoading();
        },

        async listarDatos(){
            this.cargando = true;
            let url = `${this.base_url}mov_documento/listar_datos?opciones=1`;
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('listar_datos',response.data);
                this.lista_datos = response.data.data;
                this.error_load = false;
            }).catch((error)=>{
                console.log(error);
                this.error_load = true;
            });
            this.cargando = false;
        },

        filterOnlyCapsText (value, search, item) {
            search = search.toLocaleUpperCase()
            return value != null && search != null && typeof value === 'string' && value.toString().toLocaleUpperCase().indexOf(search) !== -1
        },

        async grabar_select(item){
            console.log("item", item)
            const data = {
                id: item.id,
                opcion: item.opciones.map(opcion => (typeof opcion === 'object' ? {opcion: opcion.opcion} : {opcion})),
                multiple: true,
            };
            console.log(data);
            const url = `${this.base_url}mov_documento/grabar_opcion`;
            await this.axios.post(url, data, this.headers).then((response) => {
                let resp = response.data.data;
                console.log("resp", resp)
                this.listarDatos()
            }).catch((error)=>{
                console.log(error);
            });
        },

        async ver_select(item){
            this.mostrarLoading({titulo:"Buscando datos...",color:'green'})
            console.log("item", item)
            let id =  item.id
            let url = `${this.base_url}mov_documento/ver_opciones/${id}`;
            await this.axios.get(url, this.headers).then((response) => {
                let resp = response.data.data;
                console.log("resp", resp)
                this.ocultarLoading();
                let datos = '';
                resp.forEach(row => { datos += row.opcion + " - " });
                this.mostrarLoading({titulo:datos, color:'blue darken-4'})
            }).catch((error)=>{
                console.log(error);
            });

        },

        async eliminarMovDocumento(item) {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'Confirmar eliminación',
                message: `¿Desea eliminar documento ${item.documento}?`,
                okButton: '¡Eliminar!',
            });
            if(ok) {
                this.mostrarLoading({ titulo:`Eliminando documento: ${item.documento}...`, color:'green' })
                const url = `${this.base_url}mov_documentos/${item.id}`;
                await this.axios.delete(url, this.headers).then(res => {
                    const resp = res.data.data;
                    console.log("resp", resp)
                    this.ocultarLoading();
                    this.listarDatos();
                }).catch(error => {
                    console.log(error);
                });
            }
        },
         ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed:{
        lista_datitos(){
            let retorno = true
            const filtros = ['tipo_produccion_id', 'tipo_movimiento', 'motivo_movimiento', 'tipo_dato'];
            if(filtros.every(filtro => this[filtro] == '')) {
                return this.lista_datos;
            }
            const listita = this.lista_datos.filter( row => {
                retorno = false;

                for (const filtro of filtros) {
                    if(this[filtro] != '') {
                        if (row[filtro] == this[filtro]) {
                            retorno = true;
                        } else {
                            return false;
                        }    
                    }
                }
                return retorno;
            });
            return listita;
        },
 
        validar(){
            const datos = ['tipo_produccion_id', 'tipo_movimiento', 'motivo_movimiento', 'tipo_dato', 'documento', 'activo'];
            return datos.every(dato => {
                // Filtros específicos
                if(dato === 'activo') {
                    return [0, 1].includes(this.activo);
                }
                
                return this[dato] != ''
            });
        },
        ...mapState(['base_url','headers'])
    },
    components:{
        'alert':Alert,
        DatePicker,
        ConfirmDialogue,
    }
}
</script>
<style>
.hidden{
    display: none;
}

.theme--dark.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined){
    background: #d2d6d8 !important;
    color: #212121 !important;
}
</style>